import React, { useState } from 'react';
import { showError } from '../../../../../Helper';
import { BulkUpdateGeneralClientTrackingForSingle } from '../../../../../Services';
import InquiryStatusSelect from './InquiryStatusSelect';

const InquiryStatusChanger = ({ inquiryStatus, onUpdate, ...rest }) => {
  const [status, setStatus] = React.useState(inquiryStatus);
  const [loading, setLoading] = useState(false);
  const updateHandler = async (value) => {
    try {
      setLoading(true);
      const newItem = {
        ...rest,
        inquiryStatus: value,
      };
      await BulkUpdateGeneralClientTrackingForSingle(newItem);
      onUpdate(newItem);
      setStatus(value);
    } catch (error) {
      setStatus(inquiryStatus);
      showError('something went wrong, please try again');
    } finally {
      setLoading(false);
    }
  };
  return (
    <InquiryStatusSelect
      loading={loading}
      disabled={loading}
      onChange={updateHandler}
      status={status}
    />
  );
};
export default InquiryStatusChanger;
